<template>
  <app-layout>
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">API Tokens</h2>
    </template>

    <div class="max-w-6xl mx-auto">
      <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
        <api-token-manager
          :tokens="tokens"
          :available-permissions="availablePermissions"
          :default-permissions="defaultPermissions"
        />
      </div>
    </div>
  </app-layout>
</template>

<script>
import ApiTokenManager from './ApiTokenManager.vue';
import AppLayout from '@/Layouts/AppLayout.vue';

export default {
  props: ['tokens', 'availablePermissions', 'defaultPermissions'],

  components: {
    ApiTokenManager,
    AppLayout,
  },
};
</script>
